import { render, staticRenderFns } from "./fontSize.vue?vue&type=template&id=dec7ad9e&"
import script from "./fontSize.vue?vue&type=script&lang=js&"
export * from "./fontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dec7ad9e', component.options)
    } else {
      api.reload('dec7ad9e', component.options)
    }
    module.hot.accept("./fontSize.vue?vue&type=template&id=dec7ad9e&", function () {
      api.rerender('dec7ad9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Settings/fontSize.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Settings/fontSize.vue
// module id = dnE7
// module chunks = 0